import React from 'react';
import Carousel from './Carousel';

const Landing = () => {
  return (
    <>
      <div className="min-h-screen bg-black flex flex-col items-center justify-center">
        <section className="flex flex-col md:flex-row items-center justify-between px-6 py-12 md:py-20 max-w-7xl w-full lg:-mt-28">
          <div className="flex flex-col items-center md:items-start w-full md:w-1/2 mb-10 md:mb-0 text-center md:text-left">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              What is GemX?
            </h2>
            <p className="text-white text-lg md:text-xl mb-6 text-justify">
              GemX, powered by Google's Gemini API, is an AI assistant that transcends simple tasks. Imagine voice calls and even video chats with an assistant that gets you. Gemini lets GemX understand your needs and respond with relevant info, be it booking flights or suggesting conversation topics during a video call. The more you interact, the better it learns, making it a companion that grows with you. This AI assistant is poised to redefine the future, offering a level of personalized support unlike anything before.
            </p>
          </div>
          <div className="flex justify-center md:justify-end w-full md:w-1/2 mt-6 md:mt-14">
            <img src='/laptop.png' alt="Laptop" className="w-72 sm:w-96 md:w-[600px] h-auto" />
          </div>
        </section>

        <section className="flex flex-col md:flex-row-reverse items-center justify-between px-6 py-12 md:py-20 max-w-7xl w-full lg:-mt-60 md:-mt-20">
          <div className="flex flex-col items-center w-full md:w-1/2 text-center mb-10 md:mb-0">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              GemX - Mobile!
            </h2>
            <p className="text-white text-lg md:text-xl mb-6">
              All the action, on the go! <br />
              The all-new GemX - Mobile!...
            </p>
            <div className="flex justify-center w-full">
              <a
                href="https://play.google.com/store/apps/details?id=com.gemx.gemx" // Link to the APK file in the public folder
                download
                className="bg-white dark:bg-slate-900 text-black px-6 py-3 rounded-lg mt-4"
              >
                Try Now
              </a>
            </div>
          </div>
          <div className="flex justify-center md:justify-start w-full md:w-1/2 mt-6 md:mt-0">
            <img src='/mobile.png' alt="Mobile" className="w-72 sm:w-96 md:w-[600px] h-auto" />
          </div>
        </section>
      </div>
      <Carousel />
    </>
  );
};

export default Landing;
